"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockSkeleton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const skeleton_1 = require("@alfalab/core-components/skeleton");
const component_context_1 = require("../context/component.context");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * <SidePanel.BlockSkeleton>
 *
 * Скелетон, который должен использоваться вместо одного блока данных,
 * которые приходят в сайдпанель с мидла и/или которые находятся внутри SidePAnel.Body в табах.
 */
const BlockSkeleton = ({ dataTestId, className }) => {
    const { isMobile, isResponsive } = (0, react_1.useContext)(component_context_1.AdditionalContext);
    const platformStyles = {
        [index_module_css_1.default.mobile]: isMobile,
        [index_module_css_1.default.responsive]: isResponsive,
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(index_module_css_1.default.component, index_module_css_1.default.paddingTop, platformStyles, className), "data-test-id": dataTestId, children: [0, 1, 2, 3].map((item) => ((0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { className: index_module_css_1.default.skeleton, visible: true }, item))) }));
};
exports.BlockSkeleton = BlockSkeleton;
